export default "__VITE_ASSET__CmbeyzIN__"